import range from 'lodash/range';
import { both, either, equals, ifElse, pipe } from 'ramda';
import { getActiveShopPaymentProcessorReader, getIsRentalShop } from '../auth/selectors';
import { PAYMENT_PROCESSOR_READER } from './payment/constants';
import { getMerchantSerialNumber } from './settings/selectors';
import { getPosMerchantId } from './barbers/selector';
import { isIosBridge } from '../iosBridge/helpers';
import {
  nonBlockingHandoffActive,
  nonBlockingHandoffSupported,
} from '../listeningMode/selectors';

export const isStripeReader = pipe(getActiveShopPaymentProcessorReader, equals(PAYMENT_PROCESSOR_READER.stripe));

const hasReaderSetting = either(isStripeReader, getMerchantSerialNumber);
const masterInsideContainer = isIosBridge;
const handoffActiveAndSupported = both(nonBlockingHandoffActive, nonBlockingHandoffSupported);
const slaveSupportsCart = handoffActiveAndSupported;
const supportsCardReader = either(masterInsideContainer, slaveSupportsCart);
const getHasCardReader = both(hasReaderSetting, supportsCardReader);

export const hasCardReader = pipe(
  ifElse(
    getIsRentalShop,
    either(getPosMerchantId, getHasCardReader),
    getHasCardReader,
  ),
  Boolean,
);

export const getMinuteOptionsForMinInterval = (minInterval = 5) => {
  const minuteOptions = range(0, 60 + minInterval, minInterval);
  const minuteOptionsNoZero = minuteOptions.slice(1);

  return { minuteOptions, minuteOptionsNoZero };
};
